import { ModalPopup, SofturaTable } from "client/CommonComponents";

const purchaseOrderHistory = (props: any) => {
  const {
    columns,
    fetchAction,
    pagesCount,
    serverTotal,
    data
  } = props;
  return (
    <>
      <div
        className={"ChangeLog changelog-bulkfleetorder"}
      >
        <div className="softura-table pe-0">
          {
            <div
              className={
                data?.length != 0
                  ? "softura-table pb-3 pe-0"
                  : "softura-table paginationNav"
              }
            >
              <SofturaTable
                data={data ?? []}
                columns={columns}
                sort={false}
                defaultPageSize={10}
                pageSizes={[10, 20, 50]}
                globalSearch={false}
                fetchAction={fetchAction}
                isServerSide={true}
                serverTotal={serverTotal}
                pagesCount={pagesCount}
                defaultPaginationPosition="Both"
                fixedHeader={true}
               data-attribute="PurchaseOrderHistory_Default_Grid" />
            </div>
          }
        </div>
      </div>
    </>
  );
};
export default purchaseOrderHistory;
